import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchImportacoes(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('importacoes', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchImportacao(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`importacoes/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    }
  },
}
